import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const weekDayIsBigPhoneUpCss = "w1k5uehi";
const weekDayCss = "wnem5q8";
const WeekDay = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'th';
  const isBigPhoneUp = useDeviceType('isBigPhoneUp');
  return <Component ref={ref} {...restProps} className={classNames(weekDayCss, {
    [weekDayIsBigPhoneUpCss]: isBigPhoneUp
  }, props.className)} />;
});
const weekDaysCss = "wlvflma";
export const WeekDays = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    weekdays,
    ...restProps
  } = props;
  const Component = AsComponent || 'tr';
  return <Component ref={ref} {...restProps} className={classNames(weekDaysCss, props.className)}>
      {weekdays.map(name => <WeekDay key={name}>{name}</WeekDay>)}
    </Component>;
});

require("./week_days.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./week_days.js");